import { Appearance } from '@/types';
import { getIsDieCutStickerPrintType } from '@/model/printType/getIsDieCutStickerPrintType';
import { getPrintTypesOfAppearance } from './getPrintTypesOfAppearance';

export function getIsStickerAppearance(appearance: Appearance) {
  const printTypes = getPrintTypesOfAppearance(appearance);
  if (printTypes.length <= 0) return false;
  // [].every() returns always true for empty arrays
  return printTypes.every(
    (printType) => getIsDieCutStickerPrintType(printType)
  );
}
